import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Form, Row, Col, Button} from 'antd'
import {PlusOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import FormModal from './FormModal'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'

@inject('reportTagStore')
@observer
class SearchForm extends Component {
  formRef = React.createRef()
  state = {
    addModalVisible: false,
  }

  componentDidMount() {
    const {reportTagStore} = this.props
    reportTagStore.onGetReportTagList({
      'pageNo': 1,
      'pageSize': PAGE_SIZE_DEFAULT,
    })
  }

  handleSearch = () => {
    const {reportTagStore} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        ...fieldsValue,
        'pageNo': 1,
        'pageSize': PAGE_SIZE_DEFAULT,
      }
      reportTagStore.onGetReportTagList(params)
    }).catch(err => {
    })
  }

  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }

  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {t} = this.props
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <Row gutter={[10, 10]}>
            <Col span={6}>
              {/* <Form.Item name="tagName" label={t(`reportTag.tagName`)}>
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item> */}
            </Col>
            <Col span={18} style={{textAlign: 'right', margin: '10px 0'}}>
              {/* <Button onClick={this.handleSearch} className="ant-btn-red">{t(`general.search`)}</Button> */}
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="add"
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)